import { ChangeEvent, FC, useCallback } from 'react';

import { FormNumberField } from 'src/components/FormNumberField/FormNumberField';
import { adminActions } from 'src/store/admin/slice';
import { useAppDispatch } from 'src/store/useAppDispatch';

export const FontSizeField: FC = () => {
  const dispatch = useAppDispatch();

  const changeFontSize = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      dispatch(
        adminActions.update({
          fontSize: e.target.value ? +e.target.value : undefined,
        }),
      );
    },
    [dispatch],
  );

  return (
    <FormNumberField
      name='fontSize'
      onChange={changeFontSize}
      size='medium'
      label='Размер шрифта'
      positive
      integer
      required
      min={1}
      fullWidth
      dataTestId='administratorFontSize'
    />
  );
};
